/**
 * @file Auth.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2021
 */

import Service from './Service'
import services from '../components/http/request'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * Authorization Management Service
 * @class
 */
class Auth extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
  }

  /**
   * Get user access
   *
   * @async
   * @function login
   * @param {Number} environment - Environment Id
   * @param {string} user - User email
   * @param {string} password - User password
   * @param {Number} attempts - Number of attempts
   * @return {Promise<json>} The json with the result
   */
  async login(environment, user, password, attempts = 1) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject("Esperado o identificador do environment")
      if (typeof user === 'undefined') reject("Esperado o email do usuário")
      if (typeof password === 'undefined') reject("Esperada a senha do usuário")
      const serviceUrl = "http://tier1.cognatis.com.br:5040"
      const request = new services({tag: 'das'})
      const endPoint = `${serviceUrl}/api/token/login`
      const data = {
        "username": window.btoa(user),
        "password": window.btoa(password),
        "loginAttempts": attempts,
        "environmentId": environment
      };
      request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get all services
   *
   * @async
   * @function getServices
   * @returns {Promise<json>} The json with the result
   */
  async getServices() {
    return new Promise((resolve, reject) => {
      const request = new services({tag: 'passport'})
      const endPoint = `/api/services`
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get all aplications
   *
   * @async
   * @function getApplication
   * @returns {Promise<json>} The json with the result
   */
  async getApplication(environmentName) {
    return new Promise((resolve, reject) => {
      if (typeof environmentName === "undefined") reject(new Error("Esperado o nome do environment"));
      const request = new services({tag: 'passport'})
      const endPoint = `/api/application/environment/${environmentName}`
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject())
    })
  }
}

export { Auth }
